import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "/", image }) {
  const siteName = "TestOpoGuardiaCivil";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Tests de Oposición Guardia Civil`;
  const desc =
    description ||
    "Plataforma profesional con tests de temario, ortografía, inglés y psicotécnicos para la oposición a la Guardia Civil. Simulacros oficiales, explicaciones y estadísticas.";
  const url = `https://www.testopoguardiacivil.com${path}`;
  const img = image || "https://images.unsplash.com/photo-1720452886623-a4dd915e4e89?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content="oposicion guardia civil, test guardia civil, temario guardia civil, ortografia guardia civil, ingles guardia civil, psicotecnicos guardia civil, simulacro guardia civil, examen guardia civil" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="es_ES" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <html lang="es" />
    </Helmet>
  );
}
